export default "__VITE_ASSET__BM4E8ib0__"